import React from 'react';
import sem1 from "../assets/sem1.png";
import sem2 from "../assets/sem2.png";
import sem3 from "../assets/sem3.png";
import sem4 from "../assets/sem4.png";
import sem5 from "../assets/sem5.png";
import sem6 from "../assets/sem6.png";
import sem7 from "../assets/sem7.png";
import sem8 from "../assets/sem8.png";

const RefBTech = () => {
  return (
    <div>
      <div className="p-5 sm:px-20 bg-slate-100 dark:bg-slate-900 dark:text-white m-5 rounded-3xl">
        <h1 className="text-center underline font-serif text-3xl font-bold text-purple-700">
          Bachelor of Technology
        </h1>
        <div className="bg-slate-200 dark:bg-slate-700 rounded-2xl my-10 py-5">
          <div className="sm:flex sm:justify-around my-5">
            <div className="my-5 mx-10">
        <img className="rounded-2xl w-full max-w-[720px] h-auto" src={sem1} alt="B.Tech Semester 1 marksheet of Subhadip Das" loading="lazy" decoding="async" />
            </div>
            <div className="my-5 mx-10">
        <img className="rounded-2xl w-full max-w-[720px] h-auto" src={sem2} alt="B.Tech Semester 2 marksheet of Subhadip Das" loading="lazy" decoding="async" />
            </div>
          </div>
          <div className="sm:flex justify-around my-5">
            <div className="my-5 mx-10">
        <img className="rounded-2xl w-full max-w-[720px] h-auto" src={sem3} alt="B.Tech Semester 3 marksheet of Subhadip Das" loading="lazy" decoding="async" />
            </div>
            <div className="my-5 mx-10">
        <img className="rounded-2xl w-full max-w-[720px] h-auto" src={sem4} alt="B.Tech Semester 4 marksheet of Subhadip Das" loading="lazy" decoding="async" />
            </div>
          </div>
          <div className="sm:flex justify-around my-5">
            <div className="my-5 mx-10">
        <img className="rounded-2xl w-full max-w-[720px] h-auto" src={sem5} alt="B.Tech Semester 5 marksheet of Subhadip Das" loading="lazy" decoding="async" />
            </div>
            <div className="my-5 mx-10">
        <img className="rounded-2xl w-full max-w-[720px] h-auto" src={sem6} alt="B.Tech Semester 6 marksheet of Subhadip Das" loading="lazy" decoding="async" />
            </div>
          </div>
          <div className="sm:flex justify-around my-5">
            <div className="my-5 mx-10">
        <img className="rounded-2xl w-full max-w-[720px] h-auto" src={sem7} alt="B.Tech Semester 7 marksheet of Subhadip Das" loading="lazy" decoding="async" />
            </div>
            <div className="my-5 mx-10">
        <img className="rounded-2xl w-full max-w-[720px] h-auto" src={sem8} alt="B.Tech Semester 8 marksheet of Subhadip Das" loading="lazy" decoding="async" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RefBTech

